import { render, staticRenderFns } from "./class-dashboard.vue?vue&type=template&id=668911e4&scoped=true&"
import script from "./class-dashboard.vue?vue&type=script&lang=js&"
export * from "./class-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./class-dashboard.vue?vue&type=style&index=0&id=668911e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668911e4",
  null
  
)

export default component.exports